import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import ArrowIcon from "@material-ui/icons/ArrowForwardIos";
import { makeStyles } from "@material-ui/core/styles";
import GroupIcon from "@material-ui/icons/Group";
import PropTypes from "prop-types";
import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import GroupService from "@services/Group";
import { uniqueKey } from "@utils/react";

const Transition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  dialogContent: {
    width: "552px",
    maxWidth: "100%",
  },
  list: {
    marginTop: 25,
    maxHeight: 480,
    overflow: "auto",
  },
  loader: {
    textAlign: "center",
  },
  itemIcon: {
    width: 28,
  },
}));

function GroupSelector(props) {
  const classes = useStyles();

  const accountId = useSelector((state) => state.account.id);

  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [filter, setFilter] = useState("");

  function loadGroups() {
    setLoading(true);
    GroupService.list(accountId)
      .then((data) => {
        pushGroups(data);
        setLoading(false);
      })
      .catch(() => {
        toast.error("Erro ao carregar lista de grupos!");
        setLoading(false);
      });
  }

  function pushGroups(data) {
    setGroups(
      data.map((group) => ({
        id: group.listId,
        name: group.name,
      }))
    );
  }

  function resetForm() {
    setLoading(false);
    setGroups([]);
    setFilter("");
  }

  function handleChangeFilter(e) {
    setFilter(e.target.value);
  }

  function handleSelect(group) {
    props.onSelect(group);
  }

  function close() {
    props.onClose();
  }

  function handleClose() {
    close();
  }

  function handleCancel() {
    close();
  }

  const processedGroups = useMemo(() => {
    return groups.filter((group) => {
      const re = new RegExp(filter, "gi");
      return re.test(group.id) || re.test(group.name);
    });
  }, [groups, filter]);

  useEffect(() => {
    if (props.show) {
      loadGroups();
    } else {
      resetForm();
    }
  }, [props.show]);

  return (
    <Dialog
      open={props.show}
      TransitionComponent={Transition}
      onClose={handleClose}
    >
      <DialogTitle>Selecionar grupo</DialogTitle>

      <DialogContent>
        <div className={classes.dialogContent}>
          <TextField
            type="text"
            name="filter"
            label="Pesquisar"
            value={filter}
            fullWidth
            variant="outlined"
            onChange={handleChangeFilter}
          />

          <div className={classes.list}>
            <List dense={!props.spaced}>
              {loading && (
                <div className={classes.loader}>
                  <Typography>Carregando...</Typography>
                </div>
              )}

              {!loading && processedGroups.length === 0 && (
                <div className={classes.loader}>
                  <Typography>Nenhum grupo encontrado</Typography>
                </div>
              )}

              {!loading &&
                processedGroups.length > 0 &&
                processedGroups.map((group) => (
                  <ListItem
                    key={uniqueKey()}
                    onClick={() => handleSelect(group)}
                    button
                  >
                    <ListItemIcon>
                      <GroupIcon className={classes.itemIcon} />
                    </ListItemIcon>

                    <ListItemText
                      primary={group.name}
                      secondary={<span>{group.id}</span>}
                    />

                    <ListItemSecondaryAction>
                      <IconButton
                        onClick={() => handleSelect(group)}
                        edge="end"
                      >
                        <ArrowIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
            </List>
          </div>
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="default">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

GroupSelector.propTypes = {
  show: PropTypes.bool,
  spaced: PropTypes.bool,
  onSelect: PropTypes.func,
  onClose: PropTypes.func,
};

GroupSelector.defaultProps = {
  show: false,
  spaced: false,
  onSelect: () => {},
  onClose: () => {},
};

export default GroupSelector;
